import moment from 'moment-timezone';

export const QUERY_DATE_FORMAT = 'YYYY-MM-DD';

export const isFirstDayOfMonth = date => {
  const momentDate = moment(date);
  return momentDate
    .clone()
    .startOf('month')
    .isSame(momentDate, 'day');
};

export const isLastDayOfMonth = date => {
  const momentDate = moment(date);
  return momentDate
    .clone()
    .endOf('month')
    .isSame(momentDate, 'day');
};
